import styled from 'styled-components';

export const StyledFilterContainer = styled.div`
  padding: 20px;
  background-color: #fff;
  margin-top: 20px;

  @media only screen and (max-width: 768px) {
    margin-top: 10px;
  }
`;

export const StyledResultsContainer = styled.div`
  margin-top: 2rem;
  padding: 20px;
  background-color: #fff;
`;

export const StyledSitemapFilterTitle = styled.h2`
  font-weight: 700;
  font-size: 13px;
  margin: 0;
  margin-bottom: 0.3rem;
  color: #1e242f;
`;

export const StyledSitemapFilterOpts = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 0.75rem;
  margin-top: 0.5rem;
`;

export const StyledTotalSpan = styled.span`
  font-size: 13px;
`;

export const StyledYearOpts = styled.span`
  font-size: 14px;
`;

export const StyledSelectedYear = styled.h4`
  font-weight: 700;
  font-size: 18px;
  margin: 0;
  margin-bottom: 0.3rem;
  color: #1e242f;
`;

export const StyledResultBox = styled.div`
  padding-top: 1rem;
`;

// Table CSS
export const StyledTable = styled.table`
  min-width: 100%;
  table-layout: fixed;
`;

export const StyledTableHeader = styled.th`
  padding: 1rem;
  background: #f8f9fc;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  text-align: left;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  transition: background 0.3s ease;
  color: #374255;
  font-size: 0.813rem;
  font-weight: 700;
`;

export const StyledTableRow = styled.tr`
  transition: background 0.3s ease-in-out;

  &:hover {
    background: #e6f7ff;
  }
`;

export const StyledTableData = styled.td`
  padding: 1rem;
  border-bottom: 1px solid #e8e8e8;
  transition: background 0.3s;
  word-wrap: break-word;
  text-align: left;
  font-size: 0.813rem;
  font-weight: 500;
  color: #374255;
  cursor: default;
`;

export const StyledTableDataAnchor = styled.a`
  color: #31acbf;
  cursor: pointer;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 1rem;
`;

export const StyledNoData = styled.div`
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  padding: 16px;
`;

export const StyledNoDataBox = styled.div`
  margin: 32px 0;
  font-size: 14px;
  color: #00000040;
`;
